module.exports = __webpack_public_path__ + "static/pic07.fc87d469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic07.jpg
// module id = 490
// module chunks = 114276838955818